<template>
  <el-dialog :title="paymentType === PAYMENT_TYPE['large'] ? $t('send_pagements.create_large_value_payment') : $t('send_pagements.create_small_value_payment')" class="diglog-card" :visible.sync="dialogTableVisible" width="540px" :close-on-click-modal="false">
    <div class="header-line" />
    <div class="section-title" />
    <div style="margin: 0 12px;">
      <el-form>
        <h2 class="font_size_title">{{ $t('merchantAccount.account_details') }}</h2>
        <el-form-item
          :label="$t('merchantAccount.available_balance') + ':'"
        >
          <span style="color: #3855F1">
            {{ total_balance | toDivideWithDot }}
          </span>
        </el-form-item>
        <!-- <div>
            <h2 class="font_size_title">{{ $t('send_pagements.business_detail') }}</h2>
            <el-form-item  :label="$t('send_pagements.single_payout_payment_type') + ':'">
              {{ paymentType === PAYMENT_TYPE['large'] ? $t('map.single_payout_payment_type_2') : $t('map.single_payout_payment_type_1')  }}
              <el-radio-group v-model="paymentType" disabled>
                <el-radio :key="1" :label="1">{{ $t('map.single_payout_payment_type_1') }}</el-radio>
                <el-radio :key="2" :label="2">{{ $t('map.single_payout_payment_type_2') }}</el-radio>
              </el-radio-group>

            </el-form-item>
            <div class="section-tip" style="font-size: 13px;">
                {{ $t('tips.standard_payment_limit') }}
            </div>
          </div> -->
      </el-form>
      <SingleLargePayoutCreateContent v-show="paymentType === 2" ref="singleLargePayoutCreateContent" :balance="total_balance" v-on="$listeners" @closeModal="closeModal" />
      <SingleStandardPayoutCreateContent v-show="paymentType === 1" ref="singleStandardPayoutCreateContent" :balance="total_balance" v-on="$listeners" @closeModal="closeModal" />

    </div>

  </el-dialog>
</template>

<script>
import { fetchOverview } from '@/api/dashboard/dashboard'
export default {
  name: 'SinglePayoutCreateModal',
  components: {
    SingleLargePayoutCreateContent: () => import('./SingleLargePayoutCreateContent.vue'),
    SingleStandardPayoutCreateContent: () => import('./SingleStandardPayoutCreateContent.vue')

  },
  data() {
    this.PAYMENT_TYPE = {
      standard: 1,
      large: 2
    }
    return {
      dialogTableVisible: false,
      paymentType: null,
      total_balance: null
    }
  },
  methods: {
    showModal(row) {
      this.dialogTableVisible = true
      if (row) {
        this.paymentType = row.paymentType
      }
      this.fetchOverview()
      this.$nextTick(() => {
        if (this.paymentType === this.PAYMENT_TYPE['large']) {
          this.$refs.singleLargePayoutCreateContent.initEnterSingleLargePayoutContent(row)
        }
        if (this.paymentType === this.PAYMENT_TYPE['standard']) {
          this.$refs.singleStandardPayoutCreateContent.initEnterSingleStandardPayoutContent()
        }
      })
    },
    fetchOverview() {
      fetchOverview().then(res => {
        if (res.code === 10000) {
          this.total_balance = res.data.total_balance
        }
      })
    },
    closeModal() {
      this.dialogTableVisible = false
    },
    handleChangePaymentType(value) {
      this.paymentType = value
    }
  }
}
</script>
<style>
.diglog-card .el-form-item__label{
  line-height: 36px;
}
.diglog-card .el-form-item {
  margin-bottom: 10px;
}
.diglog-card .el-dialog {
  border-radius: 12px;
}
.diglog-card .el-dialog__title {
  padding-left: 24px;
  color: #3855F1;
}
.diglog-card .section-title {
  margin-top: 24px;
}
</style>
<style scoped>

.font_size_title {
  font-size: 18px;
  color: #000000;
}
.mb-12{
  margin-bottom: 12px;
}
.mt-12{
  margin-top: 14px
}
</style>
